module.exports = __webpack_public_path__ + "static/img/lunBo.82f70695.png";